import React, { useState, useEffect } from 'react'

import useDominantSpeaker from 'hooks/useDominantSpeaker/useDominantSpeaker'
import { getIdentity } from 'hooks/useParticipants/useParticipants'

import { MobileWrapper } from './styles'
const ActiveSpeakerMobile = ({ uuid }) => {
    const dominantSpeaker = useDominantSpeaker()
    const [shouldShow, setShouldShow] = useState(false)

    useEffect(() => {
        setShouldShow(uuid === getIdentity(dominantSpeaker?.identity)?.uuid)
    }, [dominantSpeaker, uuid])

    const activeSpeakerContainer = <MobileWrapper />

    return shouldShow ? activeSpeakerContainer : null
}

const arePropsEqual = (prevProps, nextProps) => {
    return prevProps.uuid === nextProps.uuid
}

export default React.memo(ActiveSpeakerMobile, arePropsEqual)
